import ProductCodeMappingsDAO from "@/domains/ProductCodeMappings/ProductCodeMappingsDAO";
import Core from "@/core/Core";
import RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import RpcDataSort from "@/core/services/Rpc/RpcDataSort";
import ContextMenuItem from "@/lib/components/VContextMenu/ContextMenuItem";
import ProductCodeMapping from "@/domains/ProductCodeMappings/ProductCodeMapping";

class ProductCodeMappingsService {
  static async get(params: Parameters<typeof ProductCodeMappingsDAO.get>[0]): Promise<ProductCodeMapping|null> {
    const response = await ProductCodeMappingsDAO.get(params);
    return Core.utils.hydrate(response.data, ProductCodeMapping.fromServer);
  }

  static async getList(params?: Parameters<typeof ProductCodeMappingsDAO.getList>[0]): Promise<ProductCodeMapping[]> {
    return (await this.getListPaginated(params)).data;
  }

  static async getListPaginated(
    params?: Parameters<typeof ProductCodeMappingsDAO.getList>[0] & {
      pagination?: RpcDataPagination,
      sort?: RpcDataSort,
    }
  ): Promise<{ data: ProductCodeMapping[]; pagination: RpcDataPagination }> {
    const { pagination, sort, ...filters } = params ?? {};
    const response = await ProductCodeMappingsDAO.getList(filters, pagination, sort);
    return {
      data: Core.utils.hydrateArray(response.data, ProductCodeMapping.fromServer) as ProductCodeMapping[],
      pagination: response.meta.pagination
    }
  }

  static async add(productCodeMapping: ProductCodeMapping): Promise<number> {
    const response = await ProductCodeMappingsDAO.add(productCodeMapping);

    if (response.ok) {
      Core.showNotification.success('Связка кодов успешно создана');
    }

    return response.data;
  }

  static async update(productCodeMapping: ProductCodeMapping): Promise<boolean> {
    const response = await ProductCodeMappingsDAO.update(productCodeMapping);
    if (response.ok) {
      Core.showNotification.success('Связка кодов успешно обновлена');
    }

    return response.ok;
  }

  static async delete(id: number): Promise<boolean> {
    const response = await ProductCodeMappingsDAO.delete(id);
    if (response.ok) {
      Core.showNotification.success('Связка кодов успешно удалена');
    }

    return response.ok;
  }

  static get contextMenu(): ContextMenuItem[] {
    return [
      new ContextMenuItem(
        'Открыть',
        'open_in_new',
        (productCodeMapping: ProductCodeMapping) => {
          return Core.dialogs.ProductCodeMappingCard.showAsPromise({ id: productCodeMapping.id, productCodeMapping });
        },
        () => null,
      ),
      new ContextMenuItem(
        'Удалить',
        'delete',
        async (productCodeMapping: ProductCodeMapping) => {
          const confirmed = await Core.confirm(`Подтверждаете удаление связки продуктовых кодов №${productCodeMapping.id} ?`);
          if (confirmed) {
            return await this.delete(productCodeMapping.id);
          }
          else {
            return false;
          }
        },
        () => null,
      ),
    ];
  }

}

export default ProductCodeMappingsService;
